import {Component} from 'panel';

import {mpColors} from '../../util/colors';
import {registerMPElement} from '../../util/register-element';

import template from './index.jade';
import css from './index.styl?inline';

export default registerMPElement(
  `mp-checkbox`,
  class extends Component {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        checked: `boolean`,
        'checked-color': {type: `string`, default: mpColors[`$blue1`]},
        'checked-icon': {type: `string`, default: `checkmark`},
        disabled: `boolean`,
        focused: `boolean`,
        icon: `string`,
        'unchecked-icon': {type: `string`, default: ``},
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,

        helpers: {
          getIconAttributes: () => {
            const checked = this.attr(`checked`);
            const color = checked && this.attr(`checked-color`) !== `none` ? `white` : null;

            return {
              icon: this.attr(checked ? `checked-icon` : `unchecked-icon`),
              color,
              empty: !checked && !this.attr(`unchecked-icon`),
            };
          },

          getIconStyles: () => {
            const {checked, disabled, focused} = this.attrs();
            const checkedColor = this.attr(`checked-color`);

            // focused state, highlight border only
            if (focused && !disabled && !checked) {
              return {
                'border-color': checkedColor,
              };
            } else if (disabled || !checked || checkedColor === `none`) {
              return {};
            }

            return {
              'background-color': checkedColor,
              'border-color': checkedColor,
            };
          },
        },
      };
    }
  },
);
